export const baseURL = 'https://protest9.herokuapp.com';

export const googleURL = 'https://protest9.herokuapp.com/auth/google';
